var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C10.343 0 9.81081 0.532162 9.81081 1.18919V9.81081H1.18919C0.532162 9.81081 0 10.343 0 11C0 11.657 0.532162 12.1892 1.18919 12.1892H9.81081V20.8108C9.81081 21.4678 10.343 22 11 22C11.657 22 12.1892 21.4678 12.1892 20.8108V12.1892H20.8108C21.4678 12.1892 22 11.657 22 11C22 10.343 21.4678 9.81081 20.8108 9.81081H12.1892V1.18919C12.1892 0.532162 11.657 0 11 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/AddPlus.8ea9e4316b6364b819c37cb044833e34.svg";
export { ForwardRef as ReactComponent };